export const getHasVehicleResolved = (state) => !!state.domain.vehicleInfo.hasVehicleResolved;
//# sourceMappingURL=getHasVehicleResolved.js.map